import { SelectItemsAction } from "../..";

interface IShapefileSelectItemsActionProps {
  isDisabled?: boolean;
  setPopoverOpen?: (isOpen: boolean) => void;
  onContextMenuClose?: () => void;
}

/**
 * Select Items action for shapefiles.
 *
 * NOTE: This action is currently only implemented for the Project tree.
 * If desired for Organization/System trees, the action will need to be refactored
 * in ShapefileActions/ShapefileFolderActions to be passed in as a prop if there
 * are differences between trees, similar to the rest of the actions.
 */
export function ShapefileSelectItemsAction({
  isDisabled,
  setPopoverOpen,
  onContextMenuClose
}: IShapefileSelectItemsActionProps) {
  return (
    <SelectItemsAction
      isDisabled={isDisabled}
      setPopoverOpen={setPopoverOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
}
